import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";

const TipsReward = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-[#ECEEFF] max-w-full rounded-md p-[18px] relative">
      <div
        className="absolute top-3 right-3 size-6 flex justify-center items-center cursor-pointer hover:opacity-70 transition-opacity z-10"
        onClick={onClose}
      >
        <span className="icon icon-close-1 text-[10px] text-primary/25" />
      </div>

      <div className="flex flex-row">
        <div className="flex-1 flex flex-col justify-between items-start gap-6">
          <h2 className="text-primary text-xl font-bold max-w-50">
            {t("tips.rewardTitle")}
          </h2>
          <div className="flex gap-1.5 items-end [&>span]:text-primary leading-6">
            <span className="icon icon-rally-coin text-[18px]" />
            <span className="text-[32px] font-bold">100</span>
            <span className="text-[20px] leading-4 font-bold">coins</span>
            <span className="text-[32px] font-bold">= $1</span>
          </div>
        </div>
        <div className="flex-shrink-0 w-[78px] xs:w-[118px] items-end flex">
          <Lottie
            loop={false}
            animationData={require("../../../images/animation/complete-quest.json")}
          />
        </div>
      </div>
    </div>
  );
};

export default TipsReward;
